var progress = {
    selectors: {
        next: '[data-progress="next"]',
        area: '[data-progress="area"]',
        bar: '[data-progress="bar"]',
    },
    init: function () {
        var self = this,
            $next = $(self.selectors.next),
            $area = $(self.selectors.area),
            $bar = $(self.selectors.bar);

        if ($area.length > 0) {
            self.areaTop = $area.offset().top;
            self.areaHeight = $area.outerHeight();
            self.areaCenter = self.areaTop + self.areaHeight / 2;
            self.windowHeight = $(window).height();
            self.documentHeight = $(document.body).height();

            $(window).on('scroll', function () {
                var scrollPos = window.scrollY;
                var percentage = scrollPos / self.areaHeight;

                $bar.css('transform', 'scale(' + percentage + ', 1)');
            });

            setTimeout(function () {
                self.recalculate($area);
            }, 2000);

            setTimeout(function () {
                self.recalculate($area);
            }, 5000);

            $(window).on('resize', function () {
                self.recalculate($area);
            });

            $area.imagesLoaded(function () {
                self.recalculate($area);
            });
        }
    },
    recalculate: function ($area) {
        var self = this;

        self.areaTop = $area.offset().top;
        self.areaHeight = $area.outerHeight();
        self.areaCenter = self.areaTop + self.areaHeight / 2;
        self.windowHeight = $(window).height();
        self.documentHeight = $(document.body).height();
    },
};

export { progress };
